import type { ReactNode } from 'react';

export interface TableFrameProps {
  /** The <table>, wrapped so it can scroll horizontally rather than the page. */
  table: ReactNode;
  /** The same rows as one card each, shown when the frame itself is narrow. */
  cards: ReactNode;
}

/**
 * Establishes the container that DataTable's responsive switch queries.
 *
 * The switch is a container query, not a viewport query: the same table appears full
 * width on Partners and inside a narrower column on a partner-detail tab, so the right
 * trigger is how much room this frame has. Both renderings are in the DOM and CSS
 * decides which is shown, so no view needs to pass a mode down.
 *
 * DataTable itself lands in Phase 2. This is the frame it will be built inside.
 */
export function TableFrame({ table, cards }: TableFrameProps) {
  return (
    <div className="tableFrame">
      <div className="tableScroll">{table}</div>
      <div className="tableCards">{cards}</div>
    </div>
  );
}
